import { values, map } from 'lodash';
import { PLUGINS } from '@wix/communities-forum-client-commons/dist/src/constants/plugins-constants';
import {
  createLinkPlugin,
  createHashtagPlugin,
  createImagePlugin,
  createVideoPlugin,
  createDividerPlugin,
  createHtmlPlugin,
  createExternalMentionsPlugin,
  createCodeBlockPlugin,
  createTextColorPlugin,
  createGiphyPlugin,
  createFileUploadPlugin,
  createEmojiPlugin,
  createLinkPreviewPlugin,
} from '../rce/rce-editor';

export const ALL_PLUGINS = values(PLUGINS);
export const DEFAULT_PLUGINS = [
  PLUGINS.LINK,
  PLUGINS.HASHTAG,
  PLUGINS.MENTIONS,
  PLUGINS.TEXT_COLOR,
  PLUGINS.LINK_PREVIEW_TYPE,
];
export const PLUGINS_WITH_BOTTOM_TOOLBAR = [
  PLUGINS.IMAGE,
  PLUGINS.VIDEO,
  PLUGINS.DIVIDER,
  PLUGINS.HTML,
];

const PLUGIN_FACTORIES = {
  [PLUGINS.IMAGE]: createImagePlugin,
  [PLUGINS.VIDEO]: createVideoPlugin,
  [PLUGINS.LINK]: createLinkPlugin,
  [PLUGINS.HASHTAG]: createHashtagPlugin,
  [PLUGINS.DIVIDER]: createDividerPlugin,
  [PLUGINS.HTML]: createHtmlPlugin,
  [PLUGINS.MENTIONS]: createExternalMentionsPlugin,
  [PLUGINS.CODE_BLOCK]: createCodeBlockPlugin,
  [PLUGINS.TEXT_COLOR]: createTextColorPlugin,
  [PLUGINS.GIPHY]: createGiphyPlugin,
  [PLUGINS.FILE_UPLOAD]: createFileUploadPlugin,
  [PLUGINS.EMOJI]: createEmojiPlugin,
  [PLUGINS.LINK_PREVIEW_TYPE]: createLinkPreviewPlugin,
};

export const DISABLED_PLUGINS_ON_MOBILE = [PLUGINS.EMOJI];

export const getPlugins = names => map(names, name => PLUGIN_FACTORIES[name]);
